module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAIAAACQKrqGAAAACXBIWXMAAAsSAAALEgHS3X78AAAAlElEQVQokWP8fenSj/nz/3/8yIAbMPLzcyQmMpdxcOBXx8DAwPDz59/r11nQ1LFOnQpn/87OhrP/f/zIgtWU/7dv/926FU0QXSlE0f/btzH1M6Hx/0yY8P/2bUZVVZaCAgKmMqqqMnt7M6qqYpqKrhTTMJwOwAMGXCnj58JCwhHLwMDIz8/EkZDAyM9PQJ2gIEdCAgAOwTUybdzUPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectIrefImage/assets/iref.png
// module id = 2289
// module chunks = 1